<template>
    <div>
        <div class="zwdd" v-if='isShowZwdd'>
            <img src="../../assets/zwdd.png" alt="">
            <span>{{$t('m.No_order')}}</span>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        isShowZwdd:{
            type:Boolean,
            default:false
        }
    }
}
</script>

<style>
    .zwdd{
        margin:0 auto;
        width:100%;
        text-align: center;
        margin-top:50px;
        margin-bottom:20px;
    }
    .zwdd img{
        width:180px;
    }
    .zwdd span{
        display: block;
        margin-top:10px;
        font-size:14px;
        color:#999;
    }
</style>
